import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-account-not-verified',
    templateUrl: './account-not-verified.component.html',
    styleUrls: ['./account-not-verified.component.scss'],
    standalone: false
})
export class AccountNotVerifiedComponent {
  @Output() completeVerification: EventEmitter<boolean> = new EventEmitter<boolean>();

  onCompleteVerification() {
    this.completeVerification.emit(true);
  }
}
